// TODO: IDs to be changed to match the actual app IDs once finalized. These are just placeholders for now.
// Note: IDs may differ between DEV and PROD environments
export const APP_IDS = {
  HOME: 'home',
  CLOUD: 'cloud',
  MARKETPLACE: 'marketplace',
  BRAINBOX: 'brainbox',
  TMM: 'tmm',
  COMMAND_CENTER: 'command-center',
  SETUP: 'setup',
  ACCOUNT_SETTINGS: 'account-settings',
} as const;

// Environment-based URL constants
// TODO: Update these URLs as needed for development and production environments
// Note: Empty strings for internal routes (HOME, TMM, SETUP, ACCOUNT_SETTINGS) should use SPA navigation
const DEV_URLS = {
  [APP_IDS.HOME]: '',
  [APP_IDS.CLOUD]: 'https://tranecloud.com/',
  [APP_IDS.MARKETPLACE]: '',
  [APP_IDS.BRAINBOX]: '',
  [APP_IDS.TMM]: '',
  [APP_IDS.COMMAND_CENTER]: 'https://tcc.tis.trane.com/',
  [APP_IDS.SETUP]: '',
  [APP_IDS.ACCOUNT_SETTINGS]: '',
} as const;

const PROD_URLS = {
  [APP_IDS.HOME]: '',
  [APP_IDS.CLOUD]: '',
  [APP_IDS.MARKETPLACE]: process.env.REACT_APP_MARKETPLACE_URL || '',
  [APP_IDS.BRAINBOX]: '',
  [APP_IDS.TMM]: '',
  [APP_IDS.COMMAND_CENTER]: '',
  [APP_IDS.SETUP]: '',
  [APP_IDS.ACCOUNT_SETTINGS]: '',
} as const;

// Use TIS_ENV to determine environment (DEV/PROD)
// NODE_ENV only indicates local dev vs production build, not deployment environment
const tisEnv = process.env.REACT_APP_TIS_ENV || 'development';
const isDev = tisEnv === 'development';

export const APP_URLS = isDev ? DEV_URLS : PROD_URLS;

// AppSync Configuration
// Use environment variables for flexibility across DEV and PROD
export const APPSYNC_URL =
  process.env.REACT_APP_TIS_GQL_URL ||
  'https://56exjy53zfey5bwvnr3q5qrh2a.appsync-api.us-east-1.amazonaws.com/graphql';
export const APPSYNC_REGION = process.env.REACT_APP_TIS_GQL_REGION || 'us-east-1';
